import styled from "@emotion/styled";
import { compassColors } from "src/utils/styling";
import {
  breakpointMobileOnly,
  breakpointWideDesktopOnly,
} from "src/design-system/styles/breakpoints";
import {
  fontTitle,
  fontP2Regular,
  fontXlHeadline,
} from "src/design-system/styles/fonts";
import ChatBubble from "./images/chat-bubble.webp";
import { MainColumn } from "../core/BodyLayout";

export const Box = styled.div`
  background: ${compassColors.offWhite};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0 16px 0;
  @media ${breakpointWideDesktopOnly} {
    padding: 0 90px 52px;
  }
  @media ${breakpointMobileOnly} {
    padding: 0 16px 0;
  }
`;

export const BoxSection = styled(MainColumn)`
  justify-content: space-around;
  @media ${breakpointWideDesktopOnly} {
    flex-direction: row;
    max-width: none;
    padding-bottom: 66px;
  }
`;

export const Keyword = styled.div`
  background-color: ${compassColors.pine};
  font-family: "Untitled Serif";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: white;
  text-align: center;
  padding: 31px 0px 28px;
  @media ${breakpointWideDesktopOnly} {
    ${fontXlHeadline};
    color: white;
    padding: 35px 16px 40px;
  }
`;

export const MainTitle = styled.div`
  font-family: "Brown LL";
  font-style: normal;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.03em;
  margin: 39px auto 25px;
  @media ${breakpointWideDesktopOnly} {
    font-size: 24px;
    line-height: 21px;
    /* identical to box height, or 88% */
    text-align: center;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin: 82px auto 49px;
  }
`;

export const CTASection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px 38px;
  background-color: ${compassColors.mint};
  @media ${breakpointWideDesktopOnly} {
    background-color: ${compassColors.offWhite};
    padding: 0px;
  }
`;

export const Section = styled.div`
  text-align: center;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 37px;
  }
  @media ${breakpointWideDesktopOnly} {
    width: 30%;
    margin-bottom: 18px;
  }
`;

export const Icon = styled.img`
  width: 64px;
  @media ${breakpointWideDesktopOnly} {
    margin-top: 2px;
  }
`;

const PageText = styled.div`
  display: block;
  margin: 0 20px;
`;

export const Title = styled(PageText)`
  ${fontTitle};
  font-weight: 700;
  font-size: 18px;
  margin: 16px 0;
`;

export const Content = styled(PageText)`
  ${fontP2Regular};
  margin-top: 10px;
`;

export const Testimonial = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 400px;
  margin: 0 auto 35px;
  @media ${breakpointWideDesktopOnly} {
    flex-direction: row;
    max-width: none;
    margin: 0 auto 45px;
    padding: 83.5px;
    align-items: center;
    justify-content: center;
    gap: 100px;
    background-color: ${compassColors.mint};
  }
`;

export const Author = styled.div`
  font-family: "Brown LL";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
  margin: 35px auto 0;
  &:before {
    position: relative;
    background-image: url(${ChatBubble});
    background-size: 23px 18px;
    display: inline-block;
    width: 23px;
    margin-right: 11px;
    height: 18px;
    top: 5px;
    content: "";
  }
  @media ${breakpointWideDesktopOnly} {
    font-size: 24px;
    line-height: 26px;
    margin: 0;
    &:before {
      position: relative;
      background-image: url(${ChatBubble});
      background-size: 36px 28px;
      display: inline-block;
      width: 36px;
      margin-right: 23px;
      height: 28px;
      top: 9px;
      content: "";
    }
  }
`;

export const Quote = styled.div`
  font-family: "Untitled Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  @media ${breakpointWideDesktopOnly} {
    ${fontP2Regular};
    margin-top: 21px;
  }
  margin-top: 12px;
  text-align: center;
`;

export const QuoteBlock = styled.div`
  max-width: 400px;
  padding-left: 16px;
  padding-right: 16px;
`;
